import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MaintenanceRecordDetailFilterDto, MaintenanceRecordStatsFilterDto } from '../models/maintenance-record.model';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceRecordService {
  private apiUrl = environment.apiUrl + environment.maintenanceRecordPath;

  constructor(private http: HttpClient) { }


  getStats(filters: MaintenanceRecordStatsFilterDto): Observable<any[]> {

    return this.http.post<any[]>(`${this.apiUrl}/stats`, filters);
  }

  getStatsDetails(filters: MaintenanceRecordDetailFilterDto): Observable<any[]> {
    return this.http.post<any[]>(`${this.apiUrl}/details`, filters);
  }
}
